import { http } from '@/core/api/';

export default {
  getSchoolData(locationSchoolId, params = {}) {
    return http.get(`api/schools/getlocationschool`, {
      params: {
        ...params,
        locationSchoolId,
      },
    });
  },
  updateConfigYear(model) {
    return http.put('api/schools/updatelocationyearinfo', model);
  },
  saveConfigYear(model) {
    return http.post('api/schools/createlocationyearinfo', model);
  },
  configYearStatus(model) {
    return http.put('api/schools/updatelocationyearactivation', model);
  },
  getSchoolConfigs(id, params) {
    return http.get(`api/schools/${id}/configs`, { params });
  },
  setNpi(id, npi) {
    return http.patch(`api/schools/${id}/npi`, { npi });
  },
};
